import { useTranslations } from "next-intl";
import StatBox from "./StatBox";
import MegaIcon from "./MegaIcon";
import { IoShield } from "react-icons/io5";
import { RiSwordFill } from "react-icons/ri";
import { FaHeart } from "react-icons/fa";
import { FaPeopleGroup } from "react-icons/fa6";
import { TbRulerMeasure } from "react-icons/tb";

interface StatCardProps {
  data?: {
    att: number | null;
    def: number | null;
    sta: number | null;
    buddy_group: number | null;
    buddy_distance: number | null;
    buddy_energy: number | null;
  };
}

import { Card, CardHeader, CardTitle, CardContent } from "~/components/ui/card";

const StatCard = ({ data }: StatCardProps) => {
  const t = useTranslations("Pokemon");

  return (
    <Card className="overflow-hidden">
      <CardHeader className="pb-2">
        <CardTitle className="text-pory-blue-900 text-xl font-bold">
          {t("stats")}
        </CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-6">
        <div className="flex flex-col gap-3">
          <div className="flex flex-col gap-2">
            <div className="flex gap-2">
              <StatBox
                title={t("attack")}
                value={data?.att ?? 0}
                icon={<RiSwordFill />}
              />
              <StatBox
                title={t("defence")}
                value={data?.def ?? 0}
                icon={<IoShield />}
              />
            </div>
            <div className="flex gap-2">
              <StatBox
                title={t("healthPoints")}
                value={data?.sta ?? 0}
                icon={<FaHeart />}
              />
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-3">
          <h3 className="text-pory-blue-900 text-lg font-bold">{t("buddyGroups")}</h3>
          <div className="flex flex-col gap-2">
            <div className="flex gap-2">
              <StatBox
                title={t("group")}
                value={data?.buddy_group ?? 0}
                icon={<FaPeopleGroup />}
              />
              <StatBox
                title={t("distance")}
                value={`${data?.buddy_distance ?? 0}km`}
                icon={<TbRulerMeasure />}
              />
            </div>
            {(data?.buddy_energy ?? 0) > 0 && (
              <div className="flex gap-2">
                <StatBox
                  title={t("megaEnergyReward")}
                  value={data?.buddy_energy ?? 0}
                  icon={<MegaIcon />}
                />
              </div>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default StatCard;
